/** The moderator's unit of work. Approve, Reject and Block sit in the same place on every item. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import { Button } from "../Button/Button";
import "./QueueItem.css";

export interface QueueItemProps {
  readonly content: ReactNode;
  readonly author?: ReactNode;
  readonly activity?: ReactNode;
  /** How long this item has been held. */
  readonly waiting?: ReactNode;
  readonly onApprove?: () => void;
  readonly onReject?: () => void;
  readonly onBlock?: () => void;
  readonly className?: string;
  readonly style?: CSSProperties;
}

export function QueueItem({
  content,
  author,
  activity,
  waiting,
  onApprove,
  onReject,
  onBlock,
  className,
  style,
}: QueueItemProps) {
  return (
    <article className={cn("al-queueitem", className)} style={style}>
      <div className="al-queueitem-content">{content}</div>
      <div className="al-queueitem-meta">
        {author !== undefined ? <span className="al-queueitem-author">{author}</span> : null}
        {activity !== undefined ? <span>{activity}</span> : null}
        {waiting !== undefined ? <span className="al-tabular">{waiting}</span> : null}
      </div>
      <div className="al-queueitem-actions">
        <Button variant="primary" size="lg" onClick={() => onApprove?.()}>
          Approve
        </Button>
        <Button variant="secondary" size="lg" onClick={() => onReject?.()}>
          Reject
        </Button>
        <Button variant="destructive" size="lg" onClick={() => onBlock?.()}>
          Block
        </Button>
      </div>
    </article>
  );
}
